import { Injectable } from '@angular/core';
import { Observable} from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadServiceService {

  constructor(private http: HttpClient) { }

  private _questionId = new BehaviorSubject<string>("");
  $questionId = this._questionId.asObservable();
  publishQuestionId(questionData) {
    this._questionId.next(questionData);
  }


  
  getUploadURL(ID: string, typeOfFile: string): Observable<any> {
    let params = {
      queryType: "getS3url",
      postID: ID,
      typeOfFile: typeOfFile
    }
    
    const url = environment.uploader.apiUrl;
    return this.http.get<any>(url, { params: params });
  }
  postImageOnS3(_s3url: string, _file: File, typeOfFile: string): Observable<any> {
    let contentType = `image/${typeOfFile}`;
    if(typeOfFile == 'pdf') contentType = `application/${typeOfFile}`;
    let headers = {
      'Content-Type': contentType,
      'x-amz-acl': 'public-read'
    }
    
    return this.http.put<any>(_s3url, _file, { headers: headers });
  }

  /** Upload sensitive assessment evidence without making the S3 object public. */
  postPrivateImageOnS3(uploadUrl: string, file: File): Observable<any> {
    return this.http.put<any>(uploadUrl, file, {
      headers: { 'Content-Type': 'image/jpeg' }
    });
  }

  postFileOnS3(uploadUrl: string, file: File): Observable<any> {
    const headers = {
      'Content-Type': file.type || 'application/octet-stream',
      'x-amz-acl': 'public-read'
    };
    return this.http.put<any>(uploadUrl, file, { headers });
  }
  
  questionServiceUrl = environment.questions.apiUrl;

  createQuestion(questionBody:string){
    return this.http.post(this.questionServiceUrl,questionBody);
  }

  createType(typeBody:string){
    return this.http.post(this.questionServiceUrl,typeBody);
  }
  createAssessment(assessmentObject:string){
    return this.http.post(this.questionServiceUrl,assessmentObject);
  }

  getQuestionById(questionId:string){
    let params = {
      "queryType":"get-question-by-id",
      "questionId":questionId
    }

    return this.http.get(this.questionServiceUrl,{params:params});
  }

  getAllQuestion(){
    let params ={
      "queryType":"get-all-questions"
    }
    return this.http.get(this.questionServiceUrl,{params:params});
  }

  getAllTypes(){
    let params={
      "queryType":"get-all-types"
    }
    return this.http.get(this.questionServiceUrl,{params:params});
  }

  getAllAssessment(ageGroup:string=null){
    let params ={
      "queryType":"get-all-assessemnts",
      ...(ageGroup)&&{"ageGroup":ageGroup}
    }
    return this.http.get(this.questionServiceUrl,{params:params}) 
  }

  getAssessmentById(assessmentId:string){
    let params = {
      "queryType":"get-assessment-id",
      "assessmentId":assessmentId
    }
    return this.http.get(this.questionServiceUrl,{params:params});
  }

  createSubTypeInType(subTypeBody){
    return this.http.post(this.questionServiceUrl,subTypeBody);
  }

  getAllSubtypesByType(typeId){
    let params = {
      "queryType":"get-all-subTypes",
      "typeId":typeId
    }
    return this.http.get(this.questionServiceUrl,{params:params});
  }

  deleteQuestion(questionId:string,typeId:string){
    let params = {
      "flow_selected":"delete-question",
      "questionId":questionId,
      "typeId":typeId
    }
    return this.http.post(this.questionServiceUrl,JSON.stringify(params));
  }

  deleteSubType(subTypeDeleteBody:string){
    return this.http.post(this.questionServiceUrl,subTypeDeleteBody);
  }
  deleteType(typeDeleteBody:string){
    return this.http.post(this.questionServiceUrl,typeDeleteBody);
  }

  deleteAssessment(assessmentId:string){
    let params = {
      "flow_selected":"delete-assessment",
      "assessmentId":assessmentId
    }
    return this.http.post(this.questionServiceUrl,JSON.stringify(params));
  }

}
